import { DateFormat } from '@luna/date';

import type { PfmFeatureConfig } from './type';

export const pfmFeatureConfig: PfmFeatureConfig = {
    dateFormat: {
        monthYearLong: DateFormat.MONTH_TEXT_LONG_YEAR,
        monthYearShort: DateFormat.MONTH_YEAR_SHORT_SLASH,
        dayOrdinalMonthLong: DateFormat.DAY_OF_MONTH_ORDINAL_WITH_MONTH_WIDE,
    },
};
